import { render, staticRenderFns } from "./SurveillanceLocation.vue?vue&type=template&id=1bd04152&scoped=true&"
import script from "./SurveillanceLocation.vue?vue&type=script&lang=js&"
export * from "./SurveillanceLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd04152",
  null
  
)

export default component.exports